import { Outlet, createFileRoute } from '@tanstack/react-router';
import { requireMemberPortalAuthor } from '@/lib/route-guards/member-portal-guard';
import { MemberPortalImageUploadProvider } from '@/pages/member-portal/components/MemberPortalImageUploadProvider';

function MemberPortalManageLayout() {
	return (
		<MemberPortalImageUploadProvider>
			<Outlet />
		</MemberPortalImageUploadProvider>
	);
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/manage')({
	beforeLoad: ({ context }) => requireMemberPortalAuthor(context, '/member-portal'),
	component: MemberPortalManageLayout,
});
